// extracted by mini-css-extract-plugin
module.exports = {"login":"login__2fTn2","box":"box__2gpCZ","resetPassword":"resetPassword__3HNUW","buttonContainer":"buttonContainer__NSDVV"};